export default __webpack_public_path__ + "static/media/judy chu.79b7d4bb.jpg";